import { Box, Typography } from "@mui/material";
import { uiNeutrals } from "../../../../constants/uiNeutrals";
import { TIME_OF_DAY_OPTIONS } from "../constants";

export const TimeOfDayFilter = ({
  value,
  onChange,
  isMobile = false,
  hideBottomBorder = false,
}) => {
  return (
    <Box
      sx={{
        pb: 1.5,
        ...(hideBottomBorder ? {} : { borderBottom: "1px solid #ddd" }),
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          mb: isMobile ? 1 : 1.25,
          color: "#000",
          fontSize: isMobile ? "16px" : undefined,
          fontWeight: isMobile ? 500 : undefined,
        }}
      >
        Time of Day
      </Typography>
      {/* <Typography
        variant="caption"
        component="p"
        sx={{
          m: 0,
          mb: isMobile ? 1 : 1.25,
          color: "#666",
          fontSize: isMobile ? "13px" : "12px",
          lineHeight: 1.35,
        }}
      >
        Match deals to when you plan to go (or all-day offers).
      </Typography> */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: isMobile ? 1 : 2,
        }}
      >
        {TIME_OF_DAY_OPTIONS.map((opt) => {
          const normalized = value === "all_day" ? "" : value || "";
          const chipSelected =
            opt.key === "all_day"
              ? normalized === ""
              : normalized === opt.key;

          const handleClick = () => {
            if (opt.key === "all_day") {
              onChange("");
              return;
            }
            if (normalized === opt.key) {
              onChange("");
              return;
            }
            onChange(opt.key);
          };

          return (
            <Box
              key={opt.key}
              onClick={handleClick}
              sx={{
                cursor: "pointer",
                background: "#fff",
                color: "#000",
                borderRadius: "20px",
                px: 2,
                py: 1,
                height: "36px",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                flexShrink: 0,
                transition: "all 0.2s ease",
                border: chipSelected ? "1px solid #000" : "1px solid #ddd",
                "&:hover": {
                  bgcolor: uiNeutrals.surface,
                },
              }}
            >
              {opt.label}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
